import React from "react";

interface IconProps {
  className?: string;
  strokeColor?: string;
  width?: number;
  height?: number;
}

function ContactIcon({ width = 24, height = 24, strokeColor = "#FBFBFB", className }: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" className={className}>
      <path
        d="M10.091 8.76057C10.9697 9.63925 10.9697 11.0639 10.091 11.9426C9.21231 12.8212 7.78769 12.8212 6.90901 11.9426C6.03033 11.0639 6.03033 9.63925 6.90901 8.76057C7.78769 7.88189 9.21231 7.88189 10.091 8.76057"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 19.1016V6.14256C2 5.01556 2.914 4.10156 4.041 4.10156H20C21.105 4.10156 22 4.99656 22 6.10156V19.1016C22 20.2066 21.105 21.1016 20 21.1016H4C2.895 21.1016 2 20.2066 2 19.1016Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 10.1016H19"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4 14.1016H15"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0953 17.1016C11.9203 16.6626 11.6503 16.2686 11.3033 15.9476V15.9476C10.7163 15.4036 9.94627 15.1016 9.14627 15.1016H7.85427C7.05427 15.1016 6.28427 15.4036 5.69727 15.9476V15.9476C5.35027 16.2686 5.08027 16.6626 4.90527 17.1016"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function BuyingProfileIcon({
  width = 24,
  height = 24,
  className,
  strokeColor = "#61646C",
}: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" className={className}>
      <path
        d="M21 16.6016V18.6016C21 20.2584 19.6569 21.6016 18 21.6016H17"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 9.60156V6.60156C3 4.94471 4.34315 3.60156 6 3.60156H7"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 7.00195C13.5 8.10652 14.3954 9.00195 15.5 9.00195C16.6046 9.00195 17.5 8.10652 17.5 7.00195"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8.60156V6.35156C10 4.83278 11.2312 3.60156 12.75 3.60156H18.25C19.7688 3.60156 21 4.83278 21 6.35156V10.7516C21 12.2703 19.7688 13.5016 18.25 13.5016H14"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 21.6016C13 20.2209 11.8807 19.1016 10.5 19.1016H5.5C4.11929 19.1016 3 20.2209 3 21.6016"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="8"
        cy="14.1016"
        r="2.5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CircleTickIcon({
  width = 41,
  height = 40,
  className,
  strokeColor = "#FBFBFB",
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 41 40"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 35V35C12.215 35 5.5 28.285 5.5 20V20C5.5 11.715 12.215 5 20.5 5V5C28.785 5 35.5 11.715 35.5 20V20C35.5 28.285 28.785 35 20.5 35Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1654 16.667L18.832 25.0003L13.832 20.0003"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { ContactIcon, BuyingProfileIcon, CircleTickIcon };
